import { useFormContext } from 'react-hook-form';
import { useHookFormConditional } from '../../builder/layout/panels/helpers/useConditional';

/**
 * Use to manage of "visible" prop for answer overview components only.
 * P.S. Used on answers preview.
 */
export const useAnswerRowConditional = (): { visible: boolean } => {
  const form = useFormContext();
  const { visible } = useHookFormConditional(form);
  return { visible };
};
